module.exports = __webpack_public_path__ + "static/media/siteLogo.6752e2e5.png";